<template>
    <div :class="className + ' form-group'">
        <input class="form-control" type="text" :placeholder="donationTotal" readonly>
    </div>
</template>

<script>
    export default {
        name: "CurrencyConversionHover",
        props: {
            amount: String,
            className: {
                type: String,
                default: 'col-6'
            },
            chosenCurrency: '',
            emoji: '',
        },
        data: () => ({
            convertedAmount: '',
            rate: '',
            calculatedAmount: ''
        }),
        methods: {
            currencyConvert() {
                this.rate = this.chosenCurrency.value;
            }
        },
        mounted() {
            this.currencyConvert();
        },
        watch: {
            emoji: function (newVal, oldVal) {
                this.currencyConvert();
            }
        },
        computed: {
            donationTotal() {
                if (this.rate !== '' && this.amount !== undefined) {
                    const rawTotal = this.amount / this.rate;
                    this.calculatedAmount = rawTotal.toFixed(2);
                    this.$emit('finalAmountChanged', this.calculatedAmount)
                    return 'The Rand equivalent is R' + this.calculatedAmount;
                } else {
                    return 'Please enter an amount';
                }
            },
            calculatedRate() {
                if (this.rate !== undefined && this.rate !== '') {
                    return '1 ' + this.chosenCurrency.description + 'currently equals R' + this.rate.toFixed(2);
                } else {
                    return 'Calculating exchange rate...';
                }

            }
        }

    }
</script>

<style scoped>

</style>
